<template>
  <custom-callout
    class-main="bg-secondary-5 custom-callout"
    :has-border="false"
    :has-gradient="false"
  >
    <div class="p-2 color-gray-6 font-16 font-weight-normal">
      Búsqueda de Información de Pagos
    </div>
    <template #edition>
      <div class="bg-secondary-3 px-4 py-4">
        <div class="row">
          <div class="col-md-4 col-sm col-12">
            <custom-drop-down
              v-model="model.service"
              fieldkey="id"
              fieldname="name"
              label="Servicio:"
              :options="services"
              placeholder="Seleccione"
            />
          </div>
          <div
            class="col-md-4 col-sm col-12 px-3 px-md-5 px-sm-3 mt-3 mt-md-0 mt-sm-3"
          >
            <custom-drop-down
              v-model="model.period"
              fieldkey="id"
              fieldname="description"
              label="Periodo:"
              :options="periods"
              placeholder="Seleccione"
            />
          </div>
          <div class="col-md-4 col-sm col-12 mt-3 mt-md-0 mt-sm-3">
            <custom-drop-down
              v-model="model.region"
              fieldkey="id"
              fieldname="name"
              label="Región:"
              :options="regions"
              placeholder="Seleccione"
            />
          </div>
          <div class="col-md-4 col-sm col-12 mt-3">
            <custom-input
              v-model="model.ssnorsie"
              icon="fa fa-search color-orange"
              label="Seguro Social o SIE:"
              left-icon
              mask-type="SieOrSSN"
              placeholder="Escriba SSN o SIE"
            />
          </div>
          <div
            class="col-4 col-sm col-12 d-flex align-items-end justify-content-end"
          >
            <action-button
              i="fa fa-search"
              variant="success ml-3 px-n5"
              @click="onSearchHandler"
            >
              Buscar
            </action-button>
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';

export default {
  name: 'PaymentInfoFilter',
  components: {
    CustomCallout,
    CustomDropDown,
    CustomInput,
    ActionButton,
  },
  props: {
    services: {
      type: Array,
      default: () => [],
    },
    periods: {
      type: Array,
      default: () => [],
    },
    regions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        service: null,
        period: null,
        region: null,
        ssnorsie: null,
      },
    };
  },
  methods: {
    onSearchHandler() {
      this.$emit('on-search', { ...this.model });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .custom-callout {
  em {
    margin-left: 20px !important;
  }
}

@media only screen and (max-width: 768px) {
  .btn-block-xs-only {
    display: block;
    width: 100%;
    margin-top: 20px;
  }
}
</style>
